// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
/* tslint:disable */
/* eslint-disable */
import "../../textstyles/fonts.css";
import "../../reset.css";
import "./TypeFilter.css";
import React, { createContext, useContext } from "react";
import {
  findSetVariantProps,
  makeCompositeDefaultProps,
} from "../../_internal_utils";
import { ContainerPrimitive } from "../../_internal_primitives";
import { RadioGroupRoot } from "../../_internal_radio_group";

const styles = [
  {
    type: "default",
    layers: {},
  },
  {
    type: "enum",
    propName: "size",
    values: [
      {
        propValue: "large850",
        layers: {},
      },
      {
        propValue: "med450",
        layers: {},
      },
      {
        propValue: "small",
        layers: {},
      },
    ],
  },
];

const defaultPropValues = [
  {
    type: "default",
    layers: {},
  },
  {
    type: "enum",
    propName: "size",
    values: [
      {
        propValue: "large850",
        layers: {},
      },
      {
        propValue: "med450",
        layers: {},
      },
      {
        propValue: "small",
        layers: {},
      },
    ],
  },
];

const variantPropTypes = [
  {
    type: "enum",
    propName: "size",
    propValues: ["large850", "med450", "small"],
  },
];

export const TypeFilterContext = createContext(null);

function TypeFilter(_props) {
  const defaults = useContext(TypeFilterContext);
  const props = { ...defaults, ..._props };
  const activeVariants = findSetVariantProps(variantPropTypes, props);
  const getCompositeDefaultProps = makeCompositeDefaultProps(
    defaultPropValues,
    activeVariants
  );
  return (
    <RadioGroupRoot
      {...props}
      key="segmented-control-root"
      addSpacing={true}
      internal={{
        projectId: "7X7HTLRqyD",
        styles: styles,
        layerId: "segmented-control-root",
        scope: "FkDTEWFjtv",
        activeVariants: activeVariants,
      }}
    >
      {(getStyle) => (
        <ContainerPrimitive
          id={"Container_AsfazQCo22"}
          className={
            "__visly_reset_7X7HTLRqyD __visly_scope_FkDTEWFjtv_AsfazQCo22"
          }
          key={"AsfazQCo22"}
          addSpacing={true}
          element={getStyle("AsfazQCo22", "htmlElement")}
        >
          {props.children}
        </ContainerPrimitive>
      )}
    </RadioGroupRoot>
  );
}

TypeFilter.__variants = [
  {
    name: "size",
    type: "group",
    variants: ["large850", "med450", "small"],
  },
];

export default TypeFilter;
